import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { TyreDiscountsDashboardQueryKeys } from "modules/TyreDiscountsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

type DeleteTyreBrandDiscountPayload = {
  tyre_discount_id: number;
  tyre_brand_discount_id: number;
};

export const useDeleteTyreBrandDiscountMutation = () =>
  useTypedMutation<DeleteTyreBrandDiscountPayload, void>({
    mutationFn: (payload: DeleteTyreBrandDiscountPayload) =>
      ApiInstance.post("/tyre_discounts/delete_brand", { tyre_brand_discount_id: payload.tyre_brand_discount_id }, ENV.dealerBaseURL),
    onSuccess: payload => {
      const discounts = typedQueryClient.getQueryData(TyreDiscountsDashboardQueryKeys.discounts);
      if (!discounts) return;

      const discountIdx = discounts.findIndex(discount => discount.id === payload.tyre_discount_id);
      if (discountIdx === -1) return;

      const tyreBrandDiscounts = discounts[discountIdx].tyre_brand_discounts;
      if (!tyreBrandDiscounts) return;

      const tyreBrandDiscountIdx = tyreBrandDiscounts.findIndex(bd => bd.id === payload.tyre_brand_discount_id);
      if (tyreBrandDiscountIdx === -1) return;

      typedQueryClient.setQueryData(
        TyreDiscountsDashboardQueryKeys.discounts,
        discounts.with(discountIdx, { ...discounts[discountIdx], tyre_brand_discounts: tyreBrandDiscounts.toSpliced(tyreBrandDiscountIdx, 1) })
      );
    }
  });
